var map = {
	"./1/10.jpg": 722,
	"./1/11.jpg": 723,
	"./1/12.jpg": 724,
	"./10/IMG_2511.jpg": 650,
	"./10/IMG_2512.jpg": 651,
	"./10/IMG_2513.jpg": 652,
	"./10/IMG_2514.jpg": 653,
	"./10/IMG_2515.jpg": 654,
	"./10/IMG_2516.jpg": 655,
	"./10/IMG_2519.jpg": 656,
	"./10/IMG_2523.jpg": 657,
	"./10/IMG_2524.jpg": 658,
	"./10/IMG_2532.jpg": 659,
	"./10/IMG_2533.jpg": 660,
	"./10/IMG_2534.jpg": 661,
	"./10/IMG_2538.jpg": 662,
	"./10/IMG_2543.jpg": 663,
	"./10/IMG_2545.jpg": 664,
	"./10/IMG_2546.jpg": 665,
	"./11/IMG_3253.jpg": 666,
	"./11/IMG_3254.jpg": 667,
	"./11/IMG_3255.jpg": 668,
	"./11/IMG_3256.jpg": 669,
	"./11/IMG_3267.jpg": 670,
	"./11/IMG_3268.jpg": 671,
	"./11/IMG_3271.jpg": 672,
	"./11/IMG_3276.jpg": 673,
	"./11/IMG_3277.jpg": 674,
	"./11/IMG_3282.jpg": 675,
	"./11/IMG_3284.jpg": 676,
	"./11/IMG_3285.jpg": 677,
	"./11/IMG_3286.jpg": 678,
	"./11/IMG_3306.jpg": 679,
	"./11/IMG_3312.jpg": 680,
	"./11/IMG_3323.jpg": 681,
	"./11/IMG_3324.jpg": 682,
	"./11/IMG_3325.jpg": 683,
	"./11/IMG_3331.jpg": 684,
	"./11/IMG_3332.jpg": 685,
	"./12/04.jpg": 686,
	"./12/05.jpg": 687,
	"./12/06.jpg": 688,
	"./12/07.jpg": 689,
	"./12/08.jpg": 690,
	"./12/09.jpg": 691,
	"./12/10.jpg": 692,
	"./12/11.jpg": 693,
	"./12/12.jpg": 694,
	"./12/34.jpg": 695,
	"./12/35.jpg": 696,
	"./12/36.jpg": 697,
	"./13/2815.jpg": 698,
	"./13/2840.jpg": 699,
	"./13/2856.jpg": 700,
	"./14/2979.jpg": 701,
	"./14/2984.jpg": 702,
	"./14/2993.jpg": 703,
	"./15/43.jpg": 704,
	"./15/44.jpg": 705,
	"./15/45.jpg": 706,
	"./16/46.jpg": 707,
	"./16/47.jpg": 708,
	"./16/48.jpg": 709,
	"./17/49.jpg": 710,
	"./17/50.jpg": 711,
	"./17/51.jpg": 712,
	"./18/52.jpg": 713,
	"./18/53.jpg": 714,
	"./18/54.jpg": 715,
	"./19/55.jpg": 716,
	"./19/56.jpg": 717,
	"./19/57.jpg": 718,
	"./19/58.jpg": 719,
	"./19/59.jpg": 720,
	"./19/60.jpg": 721,
	"./2/07.jpg": 764,
	"./2/08.jpg": 765,
	"./2/09.jpg": 766,
	"./20/61.jpg": 725,
	"./20/62.jpg": 726,
	"./20/63.jpg": 727,
	"./21/64.jpg": 728,
	"./21/65.jpg": 729,
	"./21/66.jpg": 730,
	"./22/67.jpg": 731,
	"./22/68.jpg": 732,
	"./22/69.jpg": 733,
	"./22/70.jpg": 734,
	"./23/71.jpg": 735,
	"./23/72.jpg": 736,
	"./23/73.jpg": 737,
	"./23/74.jpg": 738,
	"./23/75.jpg": 739,
	"./23/76.jpg": 740,
	"./23/77.jpg": 741,
	"./23/78.jpg": 742,
	"./24/85.jpg": 743,
	"./24/86.jpg": 744,
	"./24/87.jpg": 745,
	"./24/88.jpg": 746,
	"./24/89.jpg": 747,
	"./25/90.jpg": 748,
	"./25/91.jpg": 749,
	"./25/92.jpg": 750,
	"./25/93.jpg": 751,
	"./25/94.jpg": 752,
	"./26/79.jpg": 753,
	"./26/80.jpg": 754,
	"./26/81.jpg": 755,
	"./26/82.jpg": 756,
	"./26/83.jpg": 757,
	"./26/84.jpg": 758,
	"./27/95.jpg": 759,
	"./27/96.jpg": 760,
	"./27/97.jpg": 761,
	"./27/98.jpg": 762,
	"./28/99.jpg": 763,
	"./3/04.jpg": 767,
	"./3/05.jpg": 768,
	"./3/06.jpg": 769,
	"./4/01.jpg": 770,
	"./4/02.jpg": 771,
	"./4/03.jpg": 772,
	"./5/13.jpg": 773,
	"./5/14.jpg": 774,
	"./5/15.jpg": 775,
	"./6/16.jpg": 776,
	"./6/17.jpg": 777,
	"./6/18.jpg": 778,
	"./7/19.jpg": 779,
	"./7/20.jpg": 780,
	"./7/21.jpg": 781,
	"./8/22.jpg": 782,
	"./8/23.jpg": 783,
	"./8/24.jpg": 784,
	"./9/IMG_2726.jpg": 785,
	"./9/IMG_2727.jpg": 786,
	"./9/IMG_2729.jpg": 787,
	"./9/IMG_2730.jpg": 788,
	"./9/IMG_2736.jpg": 789,
	"./9/IMG_2740.jpg": 790,
	"./9/IMG_2745.jpg": 791,
	"./9/IMG_2749.jpg": 792,
	"./9/IMG_2767.jpg": 793,
	"./9/IMG_2769.jpg": 794,
	"./9/IMG_2772.jpg": 795,
	"./9/IMG_2773.jpg": 796,
	"./9/IMG_2775.jpg": 797,
	"./9/IMG_2777.jpg": 798,
	"./9/IMG_2778.jpg": 799,
	"./9/IMG_2786.jpg": 800,
	"./9/IMG_2792.jpg": 801,
	"./9/IMG_2793.jpg": 802,
	"./9/IMG_2794.jpg": 803,
	"./9/IMG_2795.jpg": 804
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 970;


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery \.(jpg)$
// module id = 970
// module chunks = 0